import { QueryClient, useQuery } from "@tanstack/react-query";
import { topicgroupsApi } from "api/topicgroups/topicgroupsApi";
import { topicsApi } from "api/topics/topicsApi";
import { QUERIES_KEYS } from "queries";

// Topic / topic-group details change rarely - shared cache for the schedule preview popover,
// the expandable group rows and the schedule export.
const DETAILS_STALE_TIME = 5 * 60 * 1000;

export const topicGroupDetailsQueryOptions = (topicGroupId: number) => ({
  queryKey: QUERIES_KEYS.TOPIC_GROUP_DETAILS(topicGroupId),
  queryFn: () => topicgroupsApi.fetchById(topicGroupId).then((res) => res.data),
  staleTime: DETAILS_STALE_TIME,
});

export const useTopicDetailsQuery = (topicId?: number) => {
  return useQuery({
    queryKey: QUERIES_KEYS.TOPIC_DETAILS(topicId ?? 0),
    queryFn: () => topicsApi.fetchById(topicId!).then((res) => res.data),
    staleTime: DETAILS_STALE_TIME,
    enabled: !!topicId,
  });
};

export const useTopicGroupDetailsQuery = (topicGroupId?: number) => {
  return useQuery({
    ...topicGroupDetailsQueryOptions(topicGroupId ?? 0),
    enabled: !!topicGroupId,
  });
};

export const fetchTopicGroupDetails = (queryClient: QueryClient, topicGroupId: number) =>
  queryClient.fetchQuery(topicGroupDetailsQueryOptions(topicGroupId));
